export default "__VITE_ASSET__CZcHMTy9__"